import { put, call, fork, join, all } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import { getOutflowHistoriesSuccessAction } from '../actions/inflowHistoryActions'
import { getSellerHistoriesSuccessAction } from '../actions/sellerHistoryAction'
import * as api from '../api'
import { FETCH_LANDING_STATES } from '../reducers/landingReducer'
import { attemptRefreshToken } from './userSaga'

export function* fetchLandingSaga() {
  let landingFetchState = FETCH_LANDING_STATES.ERROR

  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    const [
      {
        data: { items: sellerHistoryItems },
      },
      { data: outflowHistoryData },
      { data: slashInfoData },
    ] = yield all([
      call(api.requestGetSellerHistories),
      call(api.requestGetOutflowHistories),
      call(api.requestGetSlashInfo),
    ])

    if (
      sellerHistoryItems?.length > 0 ||
      outflowHistoryData?.records?.length > 0
    ) {
      landingFetchState = FETCH_LANDING_STATES.FETCHED_IS_SELLER
    } else {
      landingFetchState = FETCH_LANDING_STATES.FETCHED_IS_NOVICE
    }

    yield put(getSellerHistoriesSuccessAction(sellerHistoryItems, true))
    yield put(getOutflowHistoriesSuccessAction(outflowHistoryData, true))
    yield put({
      type: types.GET_SLASH_INFO_SUCCESS,
      payload: slashInfoData,
    })
  } catch (err) {
    console.error('landingFetchingSaga', err)
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
    yield put({
      type: types.SET_LANDING_FETCH_STATE,
      payload: landingFetchState,
    })
  }
}
